import { observable } from "mobx";
import { APIClient } from "network-stapler";
import { API } from "../Network/API";
import { IConfiguratorGeneral } from "../Utils/Interface";
import { ProductConfigurationStore } from "./ProductConfigurationStore";
import { ZipZonesStore } from "./ZipZonesStore";

class GeneralConfigurationStore {
	@observable isInitialized: boolean = false;
	@observable isLoading: boolean = false;
	@observable configs?: IConfiguratorGeneral;
	@observable isPreviewOpen: boolean = true;
	@observable isPreviewSticky: boolean = false;
	@observable previewContentHeight: number = 0;
	productConfigurationStore?: ProductConfigurationStore;
	@observable zipZonesStore?: ZipZonesStore;

	// load all configurator general data
	async loadConfigWithProductId(apiClientDynamicBaseUrl: APIClient, productId: string, langLocal: string) {

		this.productConfigurationStore = new ProductConfigurationStore(apiClientDynamicBaseUrl, productId)

		const target = API.getConfiguratorGeneral(langLocal);
		this.isLoading = true;
		try {
			const configs = await apiClientDynamicBaseUrl.requestType<IConfiguratorGeneral>(target);
			this.configs = configs;
			this.isLoading = false;

		} catch (e) {
			console.error(e);
			this.isLoading = false;
		}
	}

	async loadZipData(apiClientDynamicBaseUrl: APIClient, langLocal: string) {
		this.zipZonesStore = new ZipZonesStore(apiClientDynamicBaseUrl, langLocal)
	}
}

const generalConfigurationStore: GeneralConfigurationStore = new GeneralConfigurationStore();

export { generalConfigurationStore };
